import React, { useEffect, useState } from "react";
import DateRangePicker from "rsuite/DateRangePicker";
//import "rsuite/dist/rsuite.min.css";
//import "rsuite/DateRangePicker/styles/index.less";
//import "./dateRangePickerExtra.css";

import {
  startOfDay,
  endOfDay,
  addDays,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
  format,
  parseISO,
} from "date-fns";
import { convertDateFormat } from "app/utils/utils";

export default function BasicDateRangePicker(props) {
  let todayDate = new Date();
  const [selectedDate, setSelectedDate] = React.useState([]);

  useEffect(() => {
    let date = props?.date;
    if (date != "") {
      var finaldate = props?.date?.split(" - ");
      // Append T00:00:00 to prevent UTC parsing shifting the date back a day
      date = [new Date(finaldate[0] + "T00:00:00"), new Date(finaldate[1] + "T00:00:00")];
      setSelectedDate(date);
    } else {
      date = [];
      setSelectedDate(date);
    }
  }, [props?.date]);
  const Ranges = props?.allowRanges
    ? [
        {
          label: "today",
          value: [
            startOfDay(new Date(todayDate)),
            endOfDay(new Date(todayDate)),
          ],
        },
        {
          label: "yesterday",
          value: [
            startOfDay(addDays(new Date(todayDate), -1)),
            endOfDay(addDays(new Date(todayDate), -1)),
          ],
        },
        {
          label: "Last 7 Days",
          value: [
            startOfDay(subDays(new Date(todayDate), 6)),
            endOfDay(new Date(todayDate)),
          ],
        },
        {
          label: "Last 30 Days",
          value: [
            startOfDay(subDays(new Date(todayDate), 29)),
            endOfDay(new Date(todayDate)),
          ],
        },
        {
          label: "This Month",
          value: [
            startOfMonth(new Date(todayDate)),
            endOfMonth(new Date(todayDate)),
          ],
        },
        {
          label: "Last Month",
          value: [
            startOfMonth(subMonths(new Date(todayDate), 1)),
            endOfMonth(subMonths(new Date(todayDate), 1)),
          ],
        },
      ]
    : [];

  const handleDateChange = (date) => {
    if (date !== null) {
      //setSelectedDate(date);
      props?.updateDateRange(
        convertDateFormat(date[0], "YYYY-MM-DD"),
        convertDateFormat(date[1], "YYYY-MM-DD")
      );
    }
  };

  return (
    <>
      <DateRangePicker
        placeholder="Select Date Range"
        placement={"bottomEnd"}
        character=" - "
        appearance={"subtle"}
        format="yyyy-MM-dd"
        value={selectedDate}
        cleanable={false}
        ranges={Ranges}
        style={{
          //borderBottom: "2px solid #949494",
          border: "1px solid #ccc",
          borderRadius: "8px",
          marginBottom: "10px",
          width: "98%",
          marginRight: "16px",
        }}
        onChange={handleDateChange}
      />
    </>
  );
}
